<div class="w-full bg-[#F0F4F4] p-1 rounded-md flex items-center h-[1.75rem]">
    <div #progressBar class="progress-indicator">
        @if (progress >= 15) {
            <span class="mr-[0.375rem]">{{ progress }}%</span>
        }
    </div>

    @if (progress < 15) {
        <div class="font-bold text-[0.75rem] font-lato text-[#5F5B5B] ml-[6px]">
            <span>{{ progress }}%</span>
        </div>
    }
</div>
